import { faFileExport, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { Button, Col, Container, Row } from "reactstrap";
import BaseInput from "../../../toolkit/baseInput";
import constants from "../../../utils/constants";
import { handleRequestError } from "../../../utils/helpers";
import { infoNotification } from "../../../utils/notifications";
import { getConciliacionData } from "../../actions/billing";
import { getClubsRequest } from "../../actions/catalogs";
import MexicanCurrency from "../common/currency";
import DatePicker from "../common/DatePicker";
import s from "./styles.scss";

interface Props {
  history: any;
  match: any;
}

interface State {
  fecha: String;
  clubId: String;
  items: any[];
  saving: boolean;
  loading: boolean;
  clubsCatalog: any[];
  storageFileId: String;
}

class ConciliacionConciliar extends React.Component<Props, State> {
  state = {
    clubsCatalog: [],
    fecha: null,
    clubId: null,
    items: [],
    saving: false,
    loading: false,
    storageFileId: null
  };

  componentDidMount() {
    this.getClubsCatalog();
  }

  getClubsCatalog = () => {
    getClubsRequest()
      .then(({ data }) => {
        this.setState({ clubsCatalog: data });
      })
      .catch(handleRequestError);
  };

  handleSearch = () => {
    const { fecha, clubId } = this.state;

    this.setState({ loading: true });

    infoNotification("Consultando datos...");

    getConciliacionData(0, fecha)
      .then(({ data }) => {
        const items = [...((data || {}).items || [])];

        //items.push({ descripcion: "TOTAL", importCrm: (data.totalCrm || 0), importeMit: (data.totalMit || 0) })
        this.setState({
          loading: false,
          items: items,
          storageFileId: data.storageFileId || 0
        });
      })
      .catch(err => {
        handleRequestError(err);
        this.setState({ loading: false, saving: false });
      });
  };

  clearFields = () => {
    this.setState({
      fecha: null,
      items: [],
      saving: false,
      loading: false,
      storageFileId: null
    });
  };

  columns = [
    {
      Header: "Club",
      accessor: "clubNombre",
      className: "text-wrap"
    },
    {
      Header: "Fecha",
      accessor: "fecha",
      className: "text-center"
    },
    {
      Header: "Proceso",
      accessor: "proceso",
      className: "text-center"
    },
    {
      Header: "Operación",
      accessor: "operacion",
      className: "text-center"
    },
    {
      Header: "Referencia",
      accessor: "referencia",
      className: "text-center"
    },
    {
      Header: "Afiliación",
      accessor: "afiliacion",
      className: "text-center"
    },
    {
      Header: "Forma de pago",
      accessor: "formaPago",
      className: "text-center"
    },
    {
      Header: "Tipo tarjeta",
      accessor: "tipoTarjeta",
      className: "text-center"
    },
    {
      Header: "Importe",
      className: "text-right",
      Cell: row => {
        return <MexicanCurrency quantity={row.original.importe} />;
      }
    }
  ];

  render() {
    return (
      <Container className="w-100 px-0 pt-2">
        {/* <Row className="primaryTitle m-0 mb-2 mt-4">
          <Col xs="12">
            <p className="m-0">Consultar</p>
          </Col>
        </Row> */}

        <Row>
          {/*  <Col xs={3} className="pr-0 pt-2">
            <BaseInput
              label={"Club:"}
              id="extConfigClubFact"
              name="extConfigClubFact"
              type="select"
              value={this.state.clubId}
              options={(this.state.clubsCatalog || []).map(x => {
                return { value: x.clubId, label: x.nombre };
              })}
              onChange={(e) => {
                this.setState({ clubId: e.target.value })
              }}
            />
          </Col> */}
          <Col xs={3} className="pr-0 pt-2">
            <DatePicker
              label="Fecha"
              name="fechaInicioVigencia"
              id="fechaInicioVigencia"
              selected={this.state.fecha}
              onChange={e => {
                const date = moment(e).format("YYYY-MM-DD");
                this.setState({ fecha: date });
              }}
              errors={[]}
            />
          </Col>
          <Col xs={2} className="mt-4 pr-0 pt-2">
            <Button
              className={`${s.buttonMarginTop} ${s.primaryButton} mr-5`}
              onClick={() => {
                this.handleSearch();
              }}
              size="sm"
              block
              disabled={this.state.loading}
            >
              {!!this.state.loading ? (
                <span>
                  <FontAwesomeIcon icon={faSpinner} spin className="mr-2" />{" "}
                  Consultando
                </span>
              ) : (
                "Consultar"
              )}
            </Button>
          </Col>
        </Row>

        {/* ------------------------------------------------------- */}
        {(this.state.items || []).length > 0 && (
          <div>
            <Row className="primaryTitle m-0 mb-4 mt-4">
              <Col xs="10">
                <p className="m-0">Facturación</p>
              </Col>
            </Row>
            <Row>
              <Col xs={2}></Col>
              <Col xs={8}>
                <div>
                  {!!this.state.storageFileId && (
                    <div className={"mt-5 mb-5 text-right"}>
                      <span>Ver archivo de referencias no encontradas: </span>
                      <Button
                        id="btnReportExportCsv"
                        color="link"
                        onClick={() => {
                          const url = `${constants.BASE_URL}/${constants.DOCUMENTS_BASE_URL}/${this.state.storageFileId}`;
                          window.open(url, "_blank");
                        }}
                      >
                        <FontAwesomeIcon icon={faFileExport} color="black" />
                      </Button>
                    </div>
                  )}

                  <ReactTable
                    data={this.state.items || []}
                    columns={[
                      {
                        Header: () => (
                          <p className="font-weight-bold">CONCEPTO</p>
                        ),
                        accessor: "descripcion",
                        className: "text-wrap"
                      },
                      {
                        Header: () => (
                          <p className="font-weight-bold">
                            IMPORTE FACTURACION CRM2
                          </p>
                        ),
                        className: "text-right",
                        Cell: row => {
                          return (
                            <MexicanCurrency
                              quantity={row.original.importeCrm}
                            />
                          );
                        }
                      },
                      {
                        Header: () => (
                          <p className="font-weight-bold">
                            IMPORTE CARGA ARCHIVOS MIT
                          </p>
                        ),
                        className: "text-right",
                        Cell: row => {
                          return (
                            <MexicanCurrency
                              quantity={row.original.importeArchivos}
                            />
                          );
                        }
                      }
                    ]}
                    className="-striped -highlight"
                    sortable={false}
                    showPagination={false}
                    pageSize={(this.state.items || []).length + 2}
                    loading={this.state.loading}
                  />
                </div>
              </Col>
              <Col xs={2}></Col>
            </Row>
            {/*  <Row className="primaryTitle m-0 mb-4 mt-4">
              <Col xs="10">
                <p className="m-0">Conciliación</p>
              </Col>
            </Row> */}
          </div>
        )}
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(ConciliacionConciliar));
